import { translateFn } from '../../../../../../../utils/translator.helper';
import { GzFormFieldWebComponent } from '../../../../../../../ui/gzForm/formField';
import { GzMaintenanceWindowsContainerWebComponent } from '../maintenanceWindowsContainer';
import { PatchManagementMaintenanceWindow } from '@nirvana/shared/dtos/types/policies/common';
import { GzDialogWebComponent } from '../../../../../../../ui/gzDialog';
import { store } from '@nirvana/redux/store';
import { setSelectedIdsForPatchSummaryWindow } from '../../../../redux/customStates/patchManagement/patch-management.actions';
import { convertDropdownOptionsToMaintenanceWindows } from '../../../../utils/uiSettings/patchManagement/patch-management.values';
import { MaintenanceWindowSelectOption } from '../events/events';

export class RemoveMaintenanceWindowDialog {
  private readonly maintenanceWindowsContainerFormField: GzFormFieldWebComponent<
    GzMaintenanceWindowsContainerWebComponent,
    PatchManagementMaintenanceWindow[]
  >;
  private readonly oldValue: MaintenanceWindowSelectOption;
  private readonly newValue: MaintenanceWindowSelectOption;

  public constructor(
    maintenanceWindowsContainerFormField: GzFormFieldWebComponent<
      GzMaintenanceWindowsContainerWebComponent,
      PatchManagementMaintenanceWindow[]
    >,
    oldValue: MaintenanceWindowSelectOption,
    newValue: MaintenanceWindowSelectOption
  ) {
    this.maintenanceWindowsContainerFormField = maintenanceWindowsContainerFormField;
    this.oldValue = oldValue;
    this.newValue = newValue;
  }

  public show() {
    GzDialogWebComponent.computeCustomDialog(
      this.getWindowBody(),
      this.getWindowFooter(),
      this.getWindowTitle(),
      this.cancelCallback.bind(this),
      this.confirmCallback.bind(this)
    );
  }

  private cancelCallback() {
    this.maintenanceWindowsContainerFormField.value = convertDropdownOptionsToMaintenanceWindows([this.oldValue]);
  }

  private confirmCallback() {
    store.dispatch(setSelectedIdsForPatchSummaryWindow([]));
  }

  private getWindowBody(): string {
    return `<p>${translateFn(
      'Removing the last maintenance window from the policy will disable the Patch Management module until you assign another maintenance window.'
    )}</p>`;
  }
  private getWindowFooter(): string {
    return `<gz-button id='confirm' type='outline' color='negative'>
       ${translateFn('Remove')}
      </gz-button>
      <gz-button id='cancel' type='outline' color='secondary'>
        ${translateFn('Cancel')}
      </gz-button>`;
  }

  private getWindowTitle(): string {
    return translateFn('Remove maintenance window?');
  }
}
